import { IButtonStyles, mergeStyles } from "@fluentui/react";

export const formCredentialsContainerStyles = mergeStyles([{
    width: '100%',
    gap: '1dvh',
    marginTop: '2dvh',
    height: 'auto',
}]);

export const mdFormCredentialsContainerStyles = mergeStyles([{
    width: '100%',
    gap: '1dvh',
    marginTop: '3.5dvh',
    height: 'auto',
}]);

export const smFormCredentialsContainerStyles = mergeStyles([{
    width: '100%',
    gap: '1dvh',
    marginTop: '3dvh',
    height: 'auto',
}]);

export const passwordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const xxlPasswordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const xlPasswordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const lgPasswordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const mdPasswordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const smPasswordLabelStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontStyle: 'italic',
    textDecoration: 'underline',
    paddingTop: '2dvh',
    color: '#B45309',
}]);

export const iconSuffixStyles: IButtonStyles = {
    icon: {
        fontSize: '1.2rem',
    }
}

//#region SUBCONTAINER

export const subContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: '4dvh'
}]);

export const xxlSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.5dvh, 3dvh, 3.5dvh)'
}]);

export const xlSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.5dvh, 3.5dvh, 3.75dvh)'
}]);

export const lgSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.25dvh, 3dvh, 3.5dvh)'
}]);

export const mdSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2dvh, 2.5dvh, 3.25dvh)'
}]);

export const smSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(1.75dvh, 2dvh, 3dvh)'
}]);

//#endregion SUBCONTAINER